var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "layerSwitcher" } }, [
    _c("div", { attrs: { id: "upperSection" } }, [
      _c(
        "div",
        [
          _c("label", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("layersSelector.dataLayer")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-field",
            [
              _c(
                "b-select",
                {
                  attrs: { disabled: _vm.isUiDisabled(), icon: "checkerboard" },
                  on: { input: _vm.baseLayerGroupChanged },
                  model: {
                    value: _vm.selectedBaseLayerGroup,
                    callback: function ($$v) {
                      _vm.selectedBaseLayerGroup = $$v
                    },
                    expression: "selectedBaseLayerGroup",
                  },
                },
                _vm._l(
                  Object.entries(_vm.groupedBaseLayers),
                  function ([key, content]) {
                    return _c("option", {
                      key: key,
                      attrs: { label: content.title },
                      domProps: { value: key },
                    })
                  }
                ),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        Object.keys(this.groupedBaseLayers[this.selectedBaseLayerGroup].params)
          .length !== 0
          ? _c(
              "div",
              { attrs: { id: "settingsDiv" } },
              _vm._l(
                Object.entries(
                  this.groupedBaseLayers[this.selectedBaseLayerGroup].params
                ),
                function ([key, params]) {
                  return _c(
                    "div",
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t(`layerSelector.layerParams.${key}`)) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-field",
                        [
                          _c(
                            "b-select",
                            {
                              attrs: {
                                disabled:
                                  _vm.isUiDisabled() || params.length === 1,
                                id: key,
                                expanded: "",
                              },
                              on: { input: _vm.selectedBaseLayerParamsChanged },
                              model: {
                                value: _vm.selectedBaseLayerParams[key],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectedBaseLayerParams,
                                    key,
                                    $$v
                                  )
                                },
                                expression: "selectedBaseLayerParams[key]",
                              },
                            },
                            _vm._l(params, function (opt) {
                              return _c("option", {
                                key: opt,
                                attrs: { label: opt },
                                domProps: { value: opt },
                              })
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }
              ),
              0
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "splitter" } }),
    _vm._v(" "),
    _c("div", { attrs: { id: "lowerSection" } }, [
      _c(
        "div",
        [
          _c("label", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("layersSelector.baseLayer")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-field",
            [
              _c(
                "b-select",
                {
                  attrs: { icon: "earth", expanded: "" },
                  on: { input: _vm.overlayLayerChanged },
                  model: {
                    value: _vm.checkedOverlayLayer,
                    callback: function ($$v) {
                      _vm.checkedOverlayLayer = $$v
                    },
                    expression: "checkedOverlayLayer",
                  },
                },
                _vm._l(_vm.overlayLayersData, function (layer, okey) {
                  return _c("option", {
                    key: okey,
                    attrs: { label: layer.title },
                    domProps: { value: okey },
                  })
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "compareButton" } },
      [
        _c(
          "b-button",
          {
            attrs: {
              disabled: _vm.isUiDisabled(),
              "icon-left": "select-compare",
              expanded: "",
            },
            on: {
              click: function ($event) {
                return _vm.addCurrentLayerToCompare()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("addLayerToComparison")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }